import { equalPrimitiveArrays as o } from "./array.js";
const c = (e, t) => {
  if (e === t)
    return !0;
  if (Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const n of Object.keys(e)) {
    const r = e[n], s = t[n];
    if (i(r) && i(s)) {
      if (!o(r, s))
        return !1;
    } else if (r !== s)
      return !1;
  }
  return !0;
}, u = (e, t) => {
  const n = {};
  for (const r of Object.keys(e))
    t.includes(r) || (n[r] = e[r]);
  return n;
};
function i(e) {
  return Array.isArray(e);
}
export {
  c as equalFlatObjects,
  u as removeKeysFromObj
};
